import { EnumFilter } from "./EnumFilter";

interface EnumWithValueFilterProps {
  columnId: string;
  options: Readonly<string[]>;
  translationKey: string;
  placeholder?: string;
}

/**
 * A specialized filter for enum values that displays both the translated label and the raw value
 * (in parentheses) for each option. Useful when users need to see both the human-readable
 * translation and the actual value being filtered.
 */
export const EnumWithValueFilter = ({
  options,
  translationKey,
  columnId,
  placeholder,
}: EnumWithValueFilterProps) => {
  return (
    <EnumFilter
      columnId={columnId}
      options={options}
      translationKey={translationKey}
      placeholder={placeholder}
      renderOption={(option, translation) => (
        <span className="flex flex-wrap items-baseline gap-x-1 break-words min-w-0 flex-1">
          <span className="break-words">{translation}</span>
          <span className="text-muted-foreground text-xs break-all">
            ({option})
          </span>
        </span>
      )}
    />
  );
};
